
import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


import { Props } from './types'

export default styled.div<Props>`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${LAYOUT.WIDTH};
  padding: 0 ${LAYOUT.PADDING};
  gap: 0;
  ${MEDIA.medium`
    flex-direction: row;
    gap: 40px;
  `}
`
